@if(template){
  <div class="template-card">
    <div class="card-image">
      <img [src]="template.thumbnailUrl" [alt]="template.name" />
      <div class="overlay">
        <button class="select-btn" (click)="onSelect()">Select Template</button>
      </div>
    </div>

    <div class="card-content">
      <h3>{{ template.name }}</h3>
      <p>{{ template.description }}</p>

      <div class="card-footer">
        <span class="category">{{ template.category }}</span>
        @if(template.isPremium){
          <span class="premium">⭐ Premium</span>
        }
      </div>
    </div>
  </div>
}